import React from "react";
import { Box, Typography } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";

const Details = ({ franchise, value }) => {
  const getFormattedName = (franchise) => {
    if (!franchise) return "";

    const businessType = franchise.businessType || "";
    const name = franchise.name || "";

    return value === 2
      ? `${franchise.memberName} - ${businessType}${
          franchise.serviceLocation ? ` - ${franchise.serviceLocation}` : ""
        }`
      : `${businessType} - ${name}`;
  };
  return (
    <Box
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
    >
      <InfoOutlined
        style={{
          marginRight: 4,
          fontSize: 18,
          color: "#f57c00",
          flexShrink: 0,
          zIndex: 1,
        }}
      />
      <Box>
        <Typography
          variant="body2"
          style={{
            fontWeight: 500,
            color: "#e65100",
            marginBottom: 2,
          }}
        >
          {`Please note that ${getFormattedName(franchise)} provides `}
          <strong>{"Wash Only"}</strong>
          {" service. Would you still like to continue?"}
        </Typography>
      </Box>
    </Box>
  );
};

export default Details;
